import React from 'react'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

import JobsTabs from './Components/JobsTabs'

class Jobs extends React.Component {
  constructor() {
    super()

    this.state = {
      tabs: [
        { title: 'Available', slug: 'available', text: 'Shows the newest 3D Projects posted by clients' },
        { title: 'Applied', slug: 'applied', text: 'List of pending 3D Projects' },
        { title: 'In progress', slug: 'in-progress', text: 'List of 3D Projects you are hired for' },
      ],
      showMore: false,
    }

    this.setShowMore = this.setShowMore.bind(this)
  }

  setShowMore(value) {
    this.setState({ showMore: value })
  }

  render() {
    return (
      <div>
        <div className="card card--flat dashboard-card--jobs">
          <div className="dashboard-card">
            <h3>
              <a href="/3d-modeling-jobs/browse">3D Projects</a> <Tooltip
                tooltipClassName="tooltip--medium"
                id="dashboard__jobs"
                content="Earn extra money and find new clients by applying to these custom model requests."
              >
                <Icon type={['far', 'question-circle']} color="grey" notSpaced />
              </Tooltip>
            </h3>
            <JobsTabs tabs={this.state.tabs} setShowMore={this.setShowMore} />
          </div>
        </div>

        {(this.state.showMore)
          && (
          <div className="card card--flat">
            <a href="/3d-modeling-jobs/browse" className="btn btn-transparent btn-block btn-show-more">Show more</a>
          </div>
          )
        }
      </div>
    )
  }
}

export default Jobs
